<app-login-header></app-login-header>

<div class="container page-content">
  <div class="template-detail">
    <div *ngIf="isLoading" class="spinner-container">
      <mat-spinner></mat-spinner>
    </div>
    <form [formGroup]="signupForm" class="example-form">
      <div class="header">Login to your account</div>
      <div class="mb-3">
        <div class="col-sm-12">
          <mat-label class="form-label" for="userId">UserId*</mat-label>
          <input matInput formControlName="userId" [errorStateMatcher]="matcher" required class="form-control" maxlength="50">
          <mat-error class="error-message" *ngIf="signupForm.get('userId')?.hasError('required') && (signupForm.get('userId')?.dirty || signupForm.get('userId')?.touched)">
            User Id is required
          </mat-error>
        </div>
      </div>
      <div class="mb-3">
        <div class="col-sm-12">
          <mat-label class="form-label" for="pin">PIN*</mat-label>
          <input matInput formControlName="pin" [errorStateMatcher]="matcher" required class="form-control" maxlength="50" type="password">
          <mat-error class="error-message" *ngIf="signupForm.get('pin')?.hasError('required') && (signupForm.get('pin')?.dirty || signupForm.get('pin')?.touched)">
            PIN is required
          </mat-error>
        </div>
      </div>
      <div class="mb-3">
        <div class="col-sm-12">
          <mat-label class="form-label" for="password">Password*</mat-label>
          <input matInput formControlName="password" [errorStateMatcher]="matcher" required class="form-control" maxlength="100" type="password">
          <mat-error class="error-message" *ngIf="signupForm.get('password')?.hasError('required') && (signupForm.get('password')?.dirty || signupForm.get('password')?.touched)">
            Password is required
          </mat-error>
        </div>
      </div>
      <mat-error>{{loginFailedMessage}}</mat-error>
      <div class="d-flex justify-content-end mb-4 mt-4">
        <button mat-flat-button type="button" id="submit" class="btn btn-primary" [disabled]="signupForm.invalid" (click)="onSubmit()">Sign Up</button>
      </div>
      
    </form>
    
  </div>
</div>
<app-footer></app-footer>